// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1NiBG","colMin":"styles_colMin__1rJ1Z","colCheckbox":"styles_colCheckbox__3pSWr"};